export default {
  title: {
    add: 'Lisää skripti',
    update: 'Päivitä skripti',
  },
  form: {
    strategy: {
      label: 'Strategia',
      placeholder: 'Valitse strategia',
    },
    source: {
      label: 'Lähde (src)',
      placeholder: 'Syötä lähde',
    },
    async: {
      label: 'Asynkroninen',
      placeholder: 'Valitse asynkroninen',
    },
    content: {
      label: 'Sisältö',
      placeholder: 'Syötä sisältö',
    },
  },
  alert: {
    use_case: 'Käyttötapaus',
  },
  buttons: {
    save: 'Tallenna',
  },
};
